import { ElementType } from "@easy-email-pro-core/constants";
import { ShowElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import React from "react";

export type ShowElementProps = Omit<ShowElement["data"], "component"> & {
  idx?: string | null;
  children: ShowElement["data"]["component"];
};

export function Show(props: ShowElementProps) {
  const { idx, children: propsChildren, ...rest } = props;

  const node: ShowElement = {
    type: ElementType.SHOW,
    data: {
      ...rest,
      component: propsChildren,
    },
    attributes: {},
    children: [],
  };

  return <BlockRenderer idx={idx} node={node} children={propsChildren} />;
}
